<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >
        Sobre a seção de permissões
      </h2>

      <p
        class="text-sm leading-relaxed text-gray-800 mb-3"
      >
        Nesta página você gerencia as permissões do sistema. Cada permissão
        representa um tipo de acesso (por exemplo, ler, criar, editar ou
        excluir) aplicado a uma tabela ou recurso específico, como textos,
        notas, atividades ou grupos.
      </p>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>
          Use o campo de busca para localizar permissões rapidamente pelo nome.
        </li>
        <li>
          Clique em <strong>Adicionar Permissão</strong> para cadastrar uma nova
          permissão, definindo nome, descrição e a
          <strong>tabela referenciada</strong>.
        </li>
        <li>
          Abra o menu de ações na coluna <strong>Ações</strong> para editar,
          visualizar detalhes ou excluir uma permissão.
        </li>
        <li>
          Marque várias permissões na primeira coluna para realizar
          <strong>exclusões em lote</strong> pelo menu
          <strong>Ações em lote</strong>.
        </li>
        <li>
          Clique sobre qualquer linha da tabela para abrir o
          <strong>card de detalhes</strong> da permissão.
        </li>
        <li>
          As permissões cadastradas aqui podem ser associadas, em outras telas,
          a usuários, grupos, textos, atividades ou notas, de acordo com o
          modelo de segurança da aplicação.
        </li>
        <li>
          Permissões de sistema (caso existam) podem ter edição ou exclusão
          limitadas para preservar a integridade das regras de acesso.
        </li>
      </ul>

      <div class="mt-2 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>


